$(function () {
    var EPK = EPK || {};
    EPK.popupArray = EPK.callcenterPopupArray || [];
    EPK.popupArray.push('#modal-btn-1');

    EPK.accordionTabsArray = EPK.accordionTabsArray || [];
    EPK.accordionTabsArray.push("expand-menu");

    if (EPK.popupArray instanceof Array){
        EPK.popupArray.forEach(function(btnId){
            $(btnId).magnificPopup({
                "type": 'inline',
                "preloader": false,
                'showCloseBtn': false,
                'removalDelay': 400,
                'mainClass': 'mfp-fade',
                'overflowY': 'scroll'
            });
            $('.btn-closeModal').click(
                function(e){
                    e.preventDefault();
                    $.magnificPopup.close();
                }
            );
        });
    }



    var $request_category_master_detail_id = $('#request-category-master-detail-id');
    var original = $request_category_master_detail_id.html();

    $('#request-category-master-id').change(function() {
        var val1 = $(this).val();
        $request_category_master_detail_id.html(original).find('option').each(function() {
            var val2 = $(this).data('val');
            if (val1 != val2) {
                $(this).not(':first-child').remove();
            }
        });
        if ($(this).val() == "") {
            $request_category_master_detail_id.attr('disabled', 'disabled');
        } else {
            $request_category_master_detail_id.removeAttr('disabled');
        }
    });

    if ($('#request-category-master-id').val() > 0) {
        var val1 = $('#request-category-master-id').val();
        $request_category_master_detail_id.html(original).find('option').each(function() {
            var val2 = $(this).data('val');
            if (val1 != val2) {
                $(this).not(':first-child').remove();
            }
        });
        $request_category_master_detail_id.removeAttr('disabled');
    }


    // 必須項目入力
    var requirdInput = $('.contact-article select, .contact-article input:not([type="hidden"]), .contact-article textarea');

    function requirdForm() {
        var flag = true;
        //必須項目をひとつずつチェック
        $(requirdInput).each(function (e) {
          if ($(requirdInput).eq(e).val() === "") {
            flag = false;
          }
        });

        // チェックボックス確認
        if(!$('#agree').prop('checked')) {
            flag = false;
        }

        // ボタン状態変更
        if (flag) {
          $('.agreement input[type="submit"]').prop("disabled", false);
        }
        else {
          $('.agreement input[type="submit"]').prop("disabled", true);
        }
    }
    
    // 入力確認
    requirdForm();

    $(requirdInput).change(function () {
        requirdForm();
    });
    $('#agree').on('click', function(){
        requirdForm();
    });

});
